
const searchFold = {
  state: {
    isFold:false,

  },

  mutations: {
    set_isFold: (state, isBol) => {
      state.isFold = !isBol
    },
  },

  actions: {

    // sdadad
    // foldAction({ commit }) {
    //     commit('set_isFold', '')
    // }
  }
}

export default searchFold



// WEBPACK FOOTER //
// ./src/store/modules/search_fold.js